import { Badge, Button, Card, List, Stack, Text } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { FaIcon } from '#components/FaIcon'
import { showPricingTableModal } from '#components/Modals'
import { CONTACT_OWNER_NOTE } from '#components/Settings/Org/PaidFeatureNote'
import { useCanUpgrade } from '#components/Settings/Org/useBillingPlan'
import { IOrg } from '#state'

import { DashboardCardGroup } from './DashboardCardGroup'
import { DashboardCardShell } from './DashboardCardShell'

import styles from './UpgradePlanCard.module.css'

export const UpgradePlanCard = observer(function UpgradePlanCard({
  org,
}: {
  org: IOrg
}) {
  const canUpgrade = useCanUpgrade(org)
  if (!org.hasNoBillingAccount) return null

  return (
    <DashboardCardShell>
      <Card className={styles.banner}>
        <DashboardCardGroup align="center" gap={20} grow px={10} py={5}>
          <Stack gap="lg" align="start">
            <Stack gap="xs">
              <Badge size="xs" variant="light">
                New
              </Badge>
              <Text fw="bold">Screenplay Pro is here!</Text>
              <Text>
                We&apos;re thrilled to introduce Screenplay Pro, a powerful new
                suite built specifically for narrative film, TV and scripted
                streaming content. Designed for professional writers and
                production teams, Screenplay Pro brings the tools you need to
                take your script from first draft through production—all in one
                place.
              </Text>
            </Stack>
            {canUpgrade ? (
              <Button color="#0070ff" onClick={() => showPricingTableModal()}>
                Upgrade Plan
              </Button>
            ) : (
              <Text c="dimmed">{CONTACT_OWNER_NOTE}</Text>
            )}
          </Stack>
          <Card className={styles.callout} py={20} px={30}>
            <Text
              ta="center"
              fw="bold"
              c="#0070ff"
              tt="uppercase"
              fz={13}
              mb={15}
            >
              Upgrade today to unlock
            </Text>
            <List spacing="xs" center p={0}>
              <List.Item
                icon={
                  <FaIcon c="#0070ff" icon="fa-circle-check" fz={14} w={18} />
                }
              >
                Production-ready tools designed for professional workflows
              </List.Item>
              <List.Item
                icon={
                  <FaIcon c="#0070ff" icon="fa-circle-check" fz={14} w={18} />
                }
              >
                Colored Revisions to keep track of changes throughout the
                writing process
              </List.Item>
              <List.Item
                icon={
                  <FaIcon c="#0070ff" icon="fa-circle-check" fz={14} w={18} />
                }
              >
                Locked pages to protect approved content and maintain production
                integrity
              </List.Item>
            </List>
          </Card>
        </DashboardCardGroup>
      </Card>
    </DashboardCardShell>
  )
})
